import React from 'react';
import { withStyles, Grid, ButtonBase, withRouter } from '../../material-ui';
import AppUtils from '../../control/apputlis';

class MTabsButton extends React.Component {


    constructor(props) {
        super(props);
        this.state = { selectIdx: 0 }
    }

    _handleClick = (idx) => {
        this.setState({ selectIdx: idx });
        this.props.onChange && this.props.onChange(idx);
    }

    render() {
        const { classes, data } = this.props;
        const { selectIdx } = this.state;
        let one = 'solid 1px #15A5B6';
        let two = 'solid 0px #15A5B6';
        return (
            <Grid container direction='row' alignItems='center' justifyContent='center' className={classes.root}>
                {
                    data.map((item, i) => (
                        <ButtonBase
                            key={i}
                            onClick={() => this._handleClick(i)}
                            className={selectIdx == i ? classes.selectedButton : classes.unselectedButton}
                            style={{
                                borderTopLeftRadius: i == 0 ? 4 : 0,
                                borderBottomLeftRadius: i == 0 ? 4 : 0,
                                borderTopRightRadius: i == data.length - 1 ? 4 : 0,
                                borderBottomRightRadius: i == data.length - 1 ? 4 : 0,
                                borderLeft: i == 0 ? one : two,
                            }}>
                            {AppUtils.getSubString(item, 6)}
                        </ButtonBase>
                    ))
                }
            </Grid>
        );
    }
}

export default withRouter(withStyles((theme) => ({
    selectedButton: {
        backgroundColor: '#15A5B6',
        border: 0,
        fontSize: 12,
        color: '#FFF',
        width: 85,
        height: 30,
    },
    unselectedButton: {
        backgroundColor: '#FFF',
        border: 'solid 1px ' + '#15A5B6',
        fontSize: 12,
        color: '#15A5B6',
        width: 85,
        height: 30,
    },
}))(MTabsButton));